import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_6: FaireProductEntity = {
  token: "atc_updated_moma_6",
  type: "product",
  name: "Creative Porcelain Mugs & Espresso Cups - Coffee Mug Set of 4",
  brandName: "MoMA Design Store",
  brandToken: "moma-design-store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0241032f67a43e5b10ad5770d4dab94d74afbf03be99655d0e2693c329bcbb97.jpeg",
  priceDollars: 50,
  msrpDollars: 60,
  description:
    "MoMA Exclusive: Cream, sugar and a touch of whimsy. These Creative Mugs and Espresso Cups bring a Memphis vibe to your coffee breaks with their colors and unusually shaped handles. Crafted from porcelain, each mug or cup is in a different upbeat color with a contrast-color handle, each in a different shape.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
